const getCreatorAccount = () => {};

export default getCreatorAccount;
